import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
	CompanyNameWrapper,
	InsightsBackgroundWrapper,
	InsightsInfoWrapper,
	InsightsWrapper,
	LoadingContainer,
	LogoWrapper,
	ModulesBackgroundWrapepr,
	ModulesInfoWrapper,
	ModulesWrapper,
	SectionWrapper,
	TableWrapper,
	TitleWrapper,
	Wrapper,
} from './SectionOne.styles';
import { Heading } from 'LandingPage/style/CommonStyles';
import SpendAnalysisImg from '../../assets/images/Spend_Analysis2.png';
import BenchmarkImg from '../../assets/images/Benchmarking.png';
import DiversityReportImg from '../../assets/images/Market_Analysis.png';
import InitiativesImg from '../../assets/images/Spend_Controller.png';
import CategoryManagementImg from '../../assets/images/Manage_Category.png';
import ApVendorDBImg from '../../assets/images/Speed_to_Market.png';
import APIcon from '../../assets/images/ap-icon.png';
import {
	ApButtonIcon,
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
	ApModal,
	ApToggleSwitch,
} from '@alixpartners/ui-components';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { AgGridReact } from '@ag-grid-community/react';
import { getLocalStorageItem, setLocalStorageItem } from 'utils/localStorage';
import { ReactComponent as TotalSpendSVG } from '../../assets/svg/total-spend-dark.svg';
import { ReactComponent as VendorSVG } from '../../assets/svg/vendor-dark.svg';
import { ReactComponent as TailSpendSVG } from '../../assets/svg/total-tail-spend-dark.svg';
import { ReactComponent as DiversitySVG } from '../../assets/svg/total-diversity-spend-dark.svg';
import { ReactComponent as BenchmarkSVG } from './../../assets/svg/benchmark-dark.svg';
import { ReactComponent as BussinessUnitSVG } from '../../assets/svg/Business unit.svg';
import { ReactComponent as CostCenterSVG } from '../../assets/svg/cost-centre-dark.svg';
import { ReactComponent as SavingsSVG } from '../../assets/svg/saving-initiatives-dark.svg';
import { ReactComponent as SavingEstimateSVG } from '../../assets/svg/Savings estimates.svg';
import { ReactComponent as GeoSVG } from '../../assets/svg/geo-dark.svg';
import { getKPI } from 'utils/apiRequests';
import { SpendCubeSettingsContext } from 'contexts/SpendCubeSettingsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { getCurrencySymbolFromOptions } from 'Investigate/utils';
import BenchmarkModule from 'LandingPage/components/ModulesSection/Benchmark/BenchmarkModule';
import SupplierDiversityModule from 'LandingPage/components/ModulesSection/SupplierDiversity/SupplierDiversityModule';
import CategoryManagementModule from 'LandingPage/components/ModulesSection/CategoryManagementModule/CategoryManagementModule';
import APVendorDBModule from 'LandingPage/components/ModulesSection/APVendorDBModule/APVendorDBModule';
import InitiativesModule from 'LandingPage/components/ModulesSection/InitiativesModule/InitiativesModule';
import AnalysisModule from 'LandingPage/components/ModulesSection/AnalysisModule/AnalysisModule';
import { SettingsContext } from 'contexts/SettingsContext';
import DynamicGrid from 'LandingPage/components/DynamicGrid/DynamicGrid';

const KPIConfig = [
	{
		id: 1,
		KPIName: 'Total Spend',
		isVisible: true,
	},
	{
		id: 2,
		KPIName: 'Diversity Vendors',
		isVisible: true,
	},
	{
		id: 3,
		KPIName: 'Business Unit',
		isVisible: true,
	},
	{
		id: 4,
		KPIName: 'Tail Spend Vendors',
		isVisible: true,
	},
	{
		id: 5,
		KPIName: 'Vendors Increased',
		isVisible: true,
	},
	{
		id: 6,
		KPIName: 'Addressable Spend',
		isVisible: true,
	},
	{
		id: 7,
		KPIName: 'Benchmarks',
		isVisible: true,
	},
	{
		id: 8,
		KPIName: 'Cost Centre',
		isVisible: false,
	},
	{
		id: 9,
		KPIName: 'Savings Initiative',
		isVisible: false,
	},
	{
		id: 10,
		KPIName: 'Geo',
		isVisible: false,
	},
];

const InitialKpiData = [
	{
		id: 1,
		name: 'Total Spend',
		isVisible: true,
		icon: TotalSpendSVG,
		heading: 0,
		description: ['Total spend over', 'LTM'],
	},
	{
		id: 2,
		name: 'Diversity Vendors',
		isVisible: true,
		icon: DiversitySVG,
		heading: 0,
		description: ['Of total spend is', 'covered by diversity vendors'],
	},
	{
		id: 3,
		name: 'Business Unit',
		isVisible: true,
		icon: BussinessUnitSVG,
		heading: 0,
		description: [null, 'Business unit has highest spend'],
	},
	{
		id: 4,
		name: 'Tail Spend Vendors',
		isVisible: true,
		icon: TailSpendSVG,
		heading: 0,
		description: ['Tail spend vendors', null],
	},
	{
		id: 5,
		name: 'Vendors Increased',
		isVisible: true,
		icon: VendorSVG,
		heading: 0,
		description: ['Vendors increase in a year', null],
	},
	{
		id: 6,
		name: 'Addressable Spend',
		isVisible: true,
		icon: SavingsSVG,
		heading: 0,
		description: ['Of total addressable spend ', 'top 15 vendor covers'],
	},
	{
		id: 7,
		name: 'Benchmarks',
		isVisible: true,
		icon: BenchmarkSVG,
		heading: 'Benchmarks',
		description: [null, null],
	},
	{
		id: 8,
		name: 'Cost Center',
		isVisible: true,
		icon: CostCenterSVG,
		heading: null,
		description: ['Spent over LTM', 'for a top cost center'],
	},
	{
		id: 9,
		name: 'Savings Estimates',
		isVisible: false,
		icon: SavingEstimateSVG,
		heading: null,
		description: ['Initial outside-in savings estimates', null],
	},
	{
		id: 10,
		name: 'Geo',
		isVisible: false,
		icon: GeoSVG,
		heading: 'Geo',
		description: [null, null],
	},
];

const keyToSaveSettings = 'clientInsights';

const toPercentage = (value, isFraction = true) => {
	let percentage = isFraction ? value * 100 : value;
	return percentage.toFixed(2) + '%';
};

const SectionOne = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [kpiData, setKpiData] = useState(InitialKpiData);
	const [SettingsModal, setSettingsModal] = useState(false);
	const [rowData, setRowData] = useState(
		getLocalStorageItem(keyToSaveSettings) === null
			? KPIConfig
			: JSON.parse(getLocalStorageItem(keyToSaveSettings))
	);
	const [modalRowData, setModalRowData] = useState(
		getLocalStorageItem(keyToSaveSettings) === null
			? KPIConfig
			: JSON.parse(getLocalStorageItem(keyToSaveSettings))
	);
	const { companyName } = useContext(SettingsContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { currency } = useContext(QueryStringContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const queryParamsWaterfallChart = useContext(QueryStringContext);
	const { settings } = useContext(SpendCubeSettingsContext);
	const { tailSpend } = settings;

	useEffect(
		() => {
			if (getLocalStorageItem(keyToSaveSettings) === null) {
				setLocalStorageItem(keyToSaveSettings, JSON.stringify(KPIConfig));
			}
			loadStats();
		}, // eslint-disable-next-line
		[]
	);

	const loadStats = async () => {
		const payload = {
			totalTailSpendVendors: tailSpend.value,
			harmonized: true,
			Skip: 0,
			Take: 9,
			dateFrom: queryParamsWaterfallChart.dateFrom,
			dateTo: queryParamsWaterfallChart.dateTo,
			currency: queryParamsWaterfallChart.currency,
			currencyType: queryParamsWaterfallChart.currencyType,
			indirectTaxonomyType: 3,
			directTaxonomyType: 1,
			includeTailSpend: false,
			getTailSpendOnly: false,
			calculateTailSpend: false,
			filters: ['sourceable', 'spendType'],
			splitSpendByDimension: 0,
		};

		try {
			const response = await getKPI(payload);
			if (response.succeeded) {
				if (response.data !== null) {
					if (response.data.length > 0) {
						setKpiData(prevKpiData => {
							const newKpiData = [...prevKpiData];

							// 1
							newKpiData[0] = {
								...newKpiData[0],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(x => x.insightType === 'Total Spend')[0]
										?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
							};

							// 2
							newKpiData[1] = {
								...newKpiData[1],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Total Diversity Spend'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
							};

							// 3
							newKpiData[2] = {
								...newKpiData[2],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Business Unit'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
								description: [
									response.data?.filter(
										x => x.insightType === 'Business Unit'
									)[0]?.value2,
									'business unit has highest spend',
								],
							};

							//4
							newKpiData[3] = {
								...newKpiData[3],
								heading: formatNumber(
									response.data?.filter(
										x => x.insightType === 'Total Tail Spend Vendors'
									)[0]?.value1
								),
							};

							//5
							newKpiData[4] = {
								...newKpiData[4],
								heading: formatNumber(
									response.data?.filter(
										x => x.insightType === 'Vendor Change'
									)[0]?.value1
								),
								value: `Vendor${
									response.data.filter(
										x => x.insightType === 'Vendor Change'
									)[0].value2
								} in a Year
								`,
							};

							// 6
							newKpiData[5] = {
								...newKpiData[5],
								heading: toPercentage(
									response.data?.filter(
										x => x.insightType === 'Top 15 Vendors Coverage'
									)[0]?.value2,
									false
								),
							};

							// 7
							const benchmarkStatus = generateBenchmarkAnalysis(
								response.data.filter(x => x.insightType === 'Benchmark')[0]
									?.matchedObjects
							);
							if (Object.keys(benchmarkStatus).length > 0) {
								newKpiData[6] = {
									...newKpiData[6],
									description: benchmarkStatus,
								};
							} else {
								newKpiData[6] = {
									...newKpiData[6],
									isVisible: false,
								};
							}

							// 8
							newKpiData[7] = {
								...newKpiData[7],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(x => x.insightType === 'Cost Center')[0]
										?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
								description: [
									'Spent over LTM',
									`for cost center-${
										response.data?.filter(
											x => x.insightType === 'Cost Center'
										)[0]?.value2
									}`,
								],
							};

							// 9
							newKpiData[8] = {
								...newKpiData[8],
								heading: `${formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Savings Initiatives'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase()} - ${formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Savings Initiatives'
									)[0]?.value2,
									currencySymbol,
									true,
									1
								).toUpperCase()}`,
							};

							// 10
							const geoStatus = generateGeoAnalysis(
								response.data?.filter(x => x.insightType === 'Geo')[0]?.geo
							);
							if (Object.keys(geoStatus).length > 0) {
								newKpiData[9] = {
									...newKpiData[9],
									description: geoStatus,
								};
							}

							return newKpiData;
						});
					}
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleToggleCard = id => {
		setModalRowData(prevItems =>
			prevItems.map(
				kpi => (kpi.id === id ? { ...kpi, isVisible: !kpi.isVisible } : kpi)
			)
		);
	};

	const columnDefs = [
		{
			field: 'KPIName',
			headerName: 'KPI',
		},
		{
			field: 'isVisible',
			headerName: 'Action',
			cellRendererFramework: params => (
				<>
					<ApToggleSwitch
						checked={params.data.isVisible}
						onChange={() => handleToggleCard(params.data.id)}
					/>
				</>
			),
		},
	];

	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				suppressMenu: true,
				flex: 1,
				comparator: () => 0,
			},
			rowData: modalRowData,
			columnDefs,
			domLayout: 'autoHeight',
		};
	};

	const handleOpenSettingsModal = () => {
		setModalRowData(rowData);
		setSettingsModal(true);
	};

	const handleCloseSettingsModal = () => {
		setSettingsModal(false);
	};

	const handleSaveCardSettings = () => {
		setRowData(modalRowData);
		setLocalStorageItem(keyToSaveSettings, JSON.stringify(rowData));
		setSettingsModal(false);
	};

	function capitalizeFirst(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	const generateBenchmarkAnalysis = data => {
		const result = [];

		data.forEach((item, idx) => {
			let status;
			const name = idx === 0 ? item.name : capitalizeFirst(item.name);
			if (item.clientSpend > item.max) {
				status = `${item.name} above benchmark`;
			} else if (item.clientSpend < item.min) {
				status = `${item.name} below benchmark`;
			} else {
				status = `${item.name} within range`;
			}
			if (idx === 0) {
				status = `${status},`;
			}
			result.push(status);
		});
		return result;
	};

	const generateGeoAnalysis = data => {
		const result = [];
		data.forEach(item => {
			let status = `${item.value2.split('/')[1]} spend coverage ${toPercentage(
				item.value1,
				false
			)}`;
			result.push(status);
		});
		return result;
	};

	const updateKpiVisibility = (mainData, subData) => {
		return mainData.map(kpi => {
			const config = subData.find(configItem => configItem.id === kpi.id);
			if (config) {
				return {
					...kpi,
					isVisible: config.isVisible,
				};
			}
			return kpi;
		});
	};

	const KPItoShow = useMemo(
		() => {
			if (!isLoading) {
				return updateKpiVisibility(kpiData, rowData);
			} else {
				return [];
			}
		},
		[isLoading, kpiData, rowData]
	);

	const Loader = () => (
		<LoadingContainer>
			<ApLoaderDefault loaderText={() => <ApLoaderText />} />
		</LoadingContainer>
	);

	return (
		<SectionWrapper>
			<LogoWrapper>
				<div>
					<img src={APIcon} alt="Main Icon" height={50} width={50} />
				</div>
				<CompanyNameWrapper>{companyName}</CompanyNameWrapper>
			</LogoWrapper>
			<Wrapper>
				<InsightsBackgroundWrapper>
					<InsightsWrapper>
						<TitleWrapper>
							<Heading>Client Insights</Heading>
						</TitleWrapper>
						<InsightsInfoWrapper id="client-info">
							{isLoading ? <Loader /> : <DynamicGrid data={KPItoShow} />}
						</InsightsInfoWrapper>
					</InsightsWrapper>
				</InsightsBackgroundWrapper>
				<ModulesBackgroundWrapepr>
					<ModulesWrapper>
						<TitleWrapper>
							<Heading>SXR Modules</Heading>
							<div id="settingIcon">
								<ApButtonIcon
									className="settingIcon"
									title={`Client Insights Settings`}
									iconName="settings"
									onClick={handleOpenSettingsModal}
								/>
							</div>
						</TitleWrapper>
						<ModulesInfoWrapper>
							<AnalysisModule
								number="1"
								title="Spend Analysis"
								subtitle="What are the top areas of spending?"
								imagePath={SpendAnalysisImg}
								modulePath="/spend"
							/>
							<BenchmarkModule
								number="2"
								title="Benchmark"
								subtitle="How does spend stack up against industry peers?"
								imagePath={BenchmarkImg}
								modulePath="/benchmark/benchmarks"
							/>
							<SupplierDiversityModule
								number="3"
								title="Market Analysis"
								subtitle="What are the alternative vendors?"
								imagePath={DiversityReportImg}
								modulePath="/market-analysis/vendor-database"
							/>

							<APVendorDBModule
								number="4"
								title="Speed to Market"
								subtitle="How to conduct category specific analysis?"
								imagePath={ApVendorDBImg}
								modulePath="/speed-to-market/category-widgets"
							/>
							<CategoryManagementModule
								number="5"
								title="Manage Category"
								subtitle="How to manage category spend?"
								imagePath={CategoryManagementImg}
								modulePath="/category-management/insights"
							/>

							<InitiativesModule
								number="6"
								title="Spend Controller"
								subtitle="How do reduce tail spend?"
								imagePath={InitiativesImg}
								modulePath="/spend-controller/baseline"
							/>
						</ModulesInfoWrapper>
					</ModulesWrapper>
				</ModulesBackgroundWrapepr>
			</Wrapper>
			{SettingsModal && (
				<ApModal
					isOpen={true}
					header="Client Insight Settings"
					isDismissible
					hasClosed={handleCloseSettingsModal}
				>
					<p>Insight</p>
					<TableWrapper>
						<div className="ag-theme-balham">
							<AgGridReact {...getGridOptions()} />
						</div>
						<div style={{ padding: '10px 0 10px 10px' }}>
							<ApButtonMain
								small
								title="Save Settings"
								onClick={handleSaveCardSettings}
							>
								Save
							</ApButtonMain>
						</div>
					</TableWrapper>
				</ApModal>
			)}
		</SectionWrapper>
	);
};

export default SectionOne;
